import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Check } from "lucide-react";

export default function PricingSection() {
  return (
    <section className="w-full py-12 md:py-24 lg:py-32 bg-gray-100 dark:bg-gray-800">
      <div className="container px-4 md:px-6 mx-auto">
        <h2 className="text-3xl font-bold tracking-tighter sm:text-4xl md:text-5xl text-center mb-8">
          <a id="pricing">Simple, Transparent Pricing</a>
        </h2>
        <p className="text-xl text-muted-foreground text-center mb-12 max-w-2xl mx-auto">
          Choose the plan that's right for you and start updating your devices
          today.
        </p>
        <div className="grid gap-8 sm:grid-cols-1 lg:grid-cols-5">
          {pricingPlans.map((plan) => (
            <Card key={plan.name} className="flex flex-col">
              <CardHeader>
                <CardTitle className="text-2xl">{plan.name}</CardTitle>
                <CardDescription>{plan.description}</CardDescription>
              </CardHeader>
              <CardContent className="flex-grow">
                <div className="text-2xl font-bold mb-4">{plan.price}</div>
                <ul className="space-y-2">
                  {plan.features.map((feature, index) => (
                    <li key={index} className="flex items-center">
                      <Check className="mr-2 h-4 w-4 text-primary" />
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>
              </CardContent>
              <CardFooter>
                {/* <Button className="w-full">{plan.buttonText}</Button> */}
                <Button asChild className="w-full">
              <a href="/beta-register">Sign Up for Beta Access</a>
            </Button>
              </CardFooter>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
}

const pricingPlans = [
  {
    name: "Personal",
    description: "Perfect for homelab enthusiasts",
    price: "Free Forever",
    features: [
      "✅ Monitor up to 5 servers",
      "✅ Real-time package status",
      "✅ Basic update scheduling",
      "✅ Community support",
    ],
    buttonText: "Get Started",
    buttonLink: "https://dash.aptfleet.com/signup",
  },
  {
    name: "Personal Plus",
    description: "Homelab users: support the project!",
    price: "Pay whatever you want",
    features: [
      "✅ Monitor up to 10 servers",
      "✅ Real-time package status",
      "✅ Basic update scheduling",
      "✅ Community support",
      "✅ Early access to new features",
      "✅ Exclusive Discord role",
      "✅ Warm and fuzzy feeling that you're helping fund the project",
      "✅ And more!",
    ],
    buttonText: "Get Started",
    buttonLink: "https://dash.aptfleet.com/signup",
  },
  {
    name: "Pro",
    description: "Ideal for small businesses",
    price: "£19/mo",
    features: [
      "✅ Monitor up to 25 servers",
      "✅ Advanced update policies",
      "✅ Reboot scheduling",
      "✅ Compliance reports",
      "✅ Priority support",
    ],
    buttonText: "Start Free Trial",
    buttonLink: "https://dash.aptfleet.com/signup",
  },
  {
    name: "Business",
    description: "Designed for growing IT teams",
    price: "£79/mo",
    features: [
      "✅ Monitor up to 100 servers",
      "✅ Audit logging & compliance reports",
      "✅ Role-based access control (RBAC)",
      "✅ Custom update groups",
      "✅ Webhooks & integrations",
      "✅ Faster support response times",
    ],
    buttonText: "Start Free Trial",
    buttonLink: "https://dash.aptfleet.com/signup",
  },
  {
    name: "Enterprise",
    description: "For large-scale deployments",
    price: "Custom",
    features: [
      "✅ Unlimited servers",
      "✅ Custom update policies & integrations",
      "✅ Dedicated account manager",
      "✅ 24/7 premium support",
      "✅ On-premises/self-hosted option",
      "✅ SAML & Single Sign-On (SSO)",
    ],
    buttonText: "Contact Sales",
  },
];
